import React, { useState, useEffect } from "react"
import { ErrorText } from "../common/errorText"
import { serviceNoRegex, serviceNoSearchRegex } from "../common/regex"
import { FlightText } from "../common/text"
import { ServiceNumberField } from "./selectorFields"

interface Props {
  serviceNumber: string
  serviceNumberTo?: string
  onChange?: (name: string, value: any, isValid: boolean) => void
  showAsSingle?: boolean
  clearErrors?: boolean
}

const ServiceNumberRange: React.FunctionComponent<Props> = ({
  serviceNumber,
  serviceNumberTo,
  onChange,
  showAsSingle
}) => {
  const [serviceNumFrom, setServiceNumFrom] = useState("")
  const [serviceNumTo, setServiceNumTo] = useState("")

  useEffect(() => {
    setServiceNumFrom(serviceNumber)
    setServiceNumTo(serviceNumberTo)
  }, [serviceNumber, serviceNumberTo])

  const onChangeSNumFrom = (n, v, i) => {
    setServiceNumFrom(v)
    onChange(n, v, i)
  }

  const onChangeSNumTo = (n, v, i) => {
    setServiceNumTo(v)
    onChange(n, v, i)
  }

  return (
    <div className="ocs-range-field">
      {!showAsSingle && <label>Serv No Range</label>}
      <div className="ocs-range">
        <div className="ocs-w-60">
          <ServiceNumberField
            caption={showAsSingle && FlightText.servNo}
            value={serviceNumFrom}
            onChange={onChangeSNumFrom}
            validator={serviceNoSearchRegex}
            validationError={ErrorText.serviceNoSearchErrorText}
          />
        </div>
        {!showAsSingle && (
          <div className={"ocs-range-field-divider"}>
            <p>-</p>
          </div>
        )}
        {!showAsSingle && (
          <div className={"ocs-range-field-last ocs-w-60"}>
            <ServiceNumberField
              name={"serviceNumberTo"}
              caption={showAsSingle && FlightText.servNo}
              value={!showAsSingle && serviceNumTo}
              onChange={onChangeSNumTo}
              validator={serviceNoRegex}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default ServiceNumberRange
